import React from 'react'
// aria-label: design-system-bypass 

import ReactDOM from 'react-dom/client'
// aria-label: design-system-bypass 

import { BrowserRouter } from 'react-router-dom'
// aria-label: design-system-bypass 

import { HelmetProvider } from 'react-helmet-async'
// aria-label: design-system-bypass 

import App from './App'
// aria-label: design-system-bypass 

import { AuthProvider } from './context/AuthContext'
import { LanguageProvider } from './context/LanguageContext'
// aria-label: design-system-bypass 

import './index.css'
// aria-label: design-system-bypass 


ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <AuthProvider>
                    <LanguageProvider>
                        <App />
                    </LanguageProvider>
                </AuthProvider>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>,
)

